import React from 'react';
import { ReferenceInput } from 'react-admin';
import { AutocompleteInput } from 'ra-ui-materialui/lib/input/AutocompleteInput';


const defaultSort = {
	field: "id",
	order: "DESC"
};


export const ThirdPartyInput = ({ size, ...props }) => (
	<ReferenceInput perPage={15} {...props} reference="third-party-apps" sort={defaultSort} filter={{ no_range: false, ...props.filter }}>
		<AutocompleteInput optionText="client_name" resettable options={{ InputProps: { size } }} />
	</ReferenceInput>
);
